import { pushCellHistory } from "../pushCellHistory";
import { State } from "../types";

export type ResetAction = Readonly<{
  type: "RESET";
}>;

export const reset = (state: State, _action: ResetAction): State => {
  return pushCellHistory(state, state.cellHistory[0]);
};
